import { Component, OnInit } from '@angular/core';
import { MatchesService } from 'src/app/shared/services/matches.service';
import { CustomDateFormatter } from './custom-date-formatter.provider';
import { ChangeDetectionStrategy,ViewChild,TemplateRef} from '@angular/core';
import { apiUrl, toFormData } from 'src/app/shared/utils';
import {startOfDay,endOfDay,subDays,addDays,endOfMonth,isSameDay,isSameMonth,addHours,startOfMonth,startOfWeek,endOfWeek,format} from 'date-fns';
import { Subject,  Observable} from 'rxjs';
import { NgForm,FormsModule } from '@angular/forms';
declare  var jQuery:  any; 
import * as moment from 'moment'



import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarDateFormatter,
  CalendarView,
} from 'angular-calendar';
import { HttpClient, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";
const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
};
interface Film {
  id: number;
  release_date: string;
  location: string;
  date_time: string;
}

function getTimezoneOffsetString(date: Date): string {
  const timezoneOffset = date.getTimezoneOffset();
  const hoursOffset = String(
    Math.floor(Math.abs(timezoneOffset / 60))
  ).padStart(2, "0");
  const minutesOffset = String(Math.abs(timezoneOffset % 60)).padEnd(2, "0");
  const direction = timezoneOffset > 0 ? "-" : "+";

  return `T00:00:00${direction}${hoursOffset}:${minutesOffset}`;
}

@Component({
  selector: 'app-fixtures',
  templateUrl: './fixtures.component.html',
  styleUrls: ['./fixtures.component.scss'],
  providers: [
    {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter,
    },
  ],
  
})
export class FixturesComponent implements OnInit {
	
  matchsList: any = [];
  
  dateList: any = [];
  next_btn: boolean = true;
  matchvalue:any = 0;
  total:any = 0;
  first_name : any;
  is_home : any;
  first_image: any;
  date_time: any;
  second_name: any;
  second_image: any;
  startdate:any = [];
	matchsrequest: any = {
	  matche_status: "Upcoming",
      team_type: "Men"
	  
  };
  featurematchestlist : any= {};
  pastmatchestlist : any= {};
  featurematchesRequest: any= {};
  pastmatchesRequest: any= {};
  featurematchesError: any;
  pastmatchesError: any;
  featurematchesSuccess: any;
  matchesrequestnew: any = {
    matche_status: 'Upcoming'
    
  };
  matchesrequestnewpast: any = {
    matche_status: 'Past'
    
  };
  

  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;

  view: CalendarView = CalendarView.Month;

  CalendarView = CalendarView;

  viewDate: Date = new Date();
  events$: Observable<CalendarEvent<{ film: Film }>[]>;
  eventspast$: Observable<CalendarEvent<{ film: Film }>[]>;

  modalData: {
    action: string;
    event: CalendarEvent;
  };

  // actions: CalendarEventAction[] = [
  //   {
  //     label: '<i class="fas fa-fw fa-pencil-alt"></i>',
  //     a11yLabel: 'Edit',
  //     onClick: ({ event }: { event: CalendarEvent }): void => {
  //       this.handleEvent('Edited', event);
  //     },
  //   },
  //   {
  //     label: '<i class="fas fa-fw fa-trash-alt"></i>',
  //     a11yLabel: 'Delete',
  //     onClick: ({ event }: { event: CalendarEvent }): void => {
  //       this.events = this.events.filter((iEvent) => iEvent !== event);
  //       this.handleEvent('Deleted', event);
  //     },
  //   },
  // ];

  refresh: Subject<any> = new Subject();
  
  // events: CalendarEvent[] = [
  //   {
  //     start: subDays(startOfDay(this.startdate), 1),
  //     end: addDays(this.startdate, 1),
  //     title: 'A 3 day event',
  //     color: colors.red,
  //     actions: this.actions,
  //     allDay: true,
  //     resizable: {
  //       beforeStart: true,
  //       afterEnd: true,
  //     },
  //     draggable: true,
  //   },
  //   {
  //     start: startOfDay(new Date()),
  //     title: 'An event with no end date',
  //     color: colors.yellow,
  //     actions: this.actions,
  //   },
  //   {
  //     start: subDays(endOfMonth(new Date()), 3),
  //     end: addDays(endOfMonth(new Date()), 3),
  //     title: 'A long event that spans 2 months',
  //     color: colors.blue,
  //     allDay: true,
  //   },
  //   {
  //     start: addHours(startOfDay(new Date()), 2),
  //     end: addHours(new Date(), 2),
  //     title: 'A draggable and resizable event',
  //     color: colors.yellow,
  //     actions: this.actions,
  //     resizable: {
  //       beforeStart: true,
  //       afterEnd: true,
  //     },
  //     draggable: true,
  //   },
  // ];

  activeDayIsOpen: boolean = true;
  constructor(
  private matchsService: MatchesService,
  private http: HttpClient,
  ) { }

  ngOnInit(): void {
    this.fetchEvents();
    this.startdate = 'Mon Jan 11 2021 10:40:23 GMT+0530 (India Standard Time)';
    console.log(new Date());
  	this.matchsService.getmatchsDate().then((data) => {
      this.dateList = data;
      console.log(this.dateList);
    });
    
    this.loadmatch();
    this.loadfeaturematches();
    this.loadpastmatches();
    jQuery(".match-name").click(function () {
      if (jQuery(this).hasClass("active")) {
        // do nothing
      } else {
        var tabid = jQuery(this).attr("id");
        jQuery(".match-name").removeClass("active");
        jQuery(this).addClass("active");
        jQuery(".match-name-content").removeClass("active");
        jQuery("#" + tabid + "-content").addClass("active");
      }
      return false;
    });
  }
  incrementqty(){
    //jQuery(alert('hello'));
    this.matchvalue = this.matchvalue + 1;
    this.loadmatch();
    
   
  }
  loadmatch(){
    this.matchsService.getmatchesList().then((data) => {
      this.matchsList = data;
     
      console.log(this.matchsList);
      this.first_name = this.matchsList.data[this.matchvalue].first_name;
      this.second_name = this.matchsList.data[this.matchvalue].second_name;
      this.first_image = this.matchsList.data[this.matchvalue].first_image;
      this.second_image = this.matchsList.data[this.matchvalue].second_image;
      this.date_time = this.matchsList.data[this.matchvalue].date_time;
      this.is_home = this.matchsList.data[this.matchvalue].home_ground;
      //console.log(count(this.matchsList));
      this.total = 0;
        this.matchsList.data.forEach(match => {
          this.total = this.total + 1;
      });
      console.log(this.total);
      //console.log(this.matchvalue);
      var nextval = parseInt(this.matchvalue) + 1;
      console.log(nextval);
      if(nextval > parseInt(this.total)){
        this.next_btn = false;
        console.log(this.next_btn);
      }

    });
  }
  
  loadfeaturematches(){
    this.featurematchesRequest = {
      matche_status: 'Upcoming',
      pagesize: 1000,
      page: 1
    }
    let request = Object.assign({}, this.featurematchesRequest)

    this.matchsService.getmatchesList(request).then(
      (res) => {
        console.log(res.status);
        
        if(res.status==0)
        {
          this.featurematchesError = res.message;
        }else{
          this.featurematchestlist = res.data;
          //console.log(res.data);
          console.log(this.featurematchestlist);
        }
      }).catch((err) => {
        this.featurematchesError = err.error.message;;
      });
  }
  loadpastmatches(){
    this.pastmatchesRequest = {
      matche_status: 'Past',
      pagesize: 1000,
      page: 1
    }
    let request = Object.assign({}, this.pastmatchesRequest)

    this.matchsService.getmatchesList(request).then(
      (res) => {
        console.log(res.status);
        
        if(res.status==0)
        {
          this.pastmatchesError = res.message;
        }else{
          this.pastmatchestlist = res.data;
          //console.log(res.data);
          console.log(this.pastmatchestlist);
        }
      }).catch((err) => {
        this.pastmatchesError = err.error.message;;
      });
  }
  fetchEvents(): void {
    const getStart: any = {
      month: startOfMonth,
      week: startOfWeek,
      day: startOfDay
    }[this.view];

    const getEnd: any = {
      month: endOfMonth,
      week: endOfWeek,
      day: endOfDay
    }[this.view];

    const params = new HttpParams()
      .set(
        "primary_release_date.gte",
        format(getStart(this.viewDate), "yyyy-MM-dd")
      )
      .set(
        "primary_release_date.lte",
        format(getEnd(this.viewDate), "yyyy-MM-dd")
      )
      .set("api_key", "0ec33936a68018857d727958dca1424f");
    let request = Object.assign({}, this.matchesrequestnew);
    let requestpast = Object.assign({}, this.matchesrequestnewpast);
    this.events$ = this.http.post("https://ashtonunited.co.uk/Ashtonunited/api/beforeauth/getmatcheslist", toFormData({Matches : request}))
      .pipe(
        map(({ data }: { data: Film[] }) => {
          return data.map((film: Film) => {
            return {
              title: film.location,

              start: new Date(
                moment(film.date_time).format('YYYY-MM-DD') + getTimezoneOffsetString(this.viewDate)
              ),

              //color: colors.yellow,
              allDay: true,
              meta: {
                film
              }
            };
          });
        })
      );

      this.eventspast$ = this.http.post("https://ashtonunited.co.uk/Ashtonunited/api/beforeauth/getmatcheslist", toFormData({Matches : requestpast}))
      .pipe(
        map(({ data }: { data: Film[] }) => {
          return data.map((film: Film) => {
            return {
              title: film.location,

              start: new Date(
                moment(film.date_time).format('YYYY-MM-DD') + getTimezoneOffsetString(this.viewDate)
              ),

              //color: colors.yellow,
              allDay: true,
              meta: {
                film
              }
            };
          });
        })
      );


  }
  
  loadmatches(): void {
    const getStart: any = {
      month: startOfMonth,
      week: startOfWeek,
      day: startOfDay
    }[this.view];

    const getEnd: any = {
      month: endOfMonth,
      week: endOfWeek,
      day: endOfDay
    }[this.view];

    const params = new HttpParams()

    
  }

  

  setView(view: CalendarView) {
    this.view = view;
  }

  dayClicked({
    date,
    events
  }: {
    date: Date;
    events: CalendarEvent<{ film: Film }>[];
  }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
        this.viewDate = date;
      }
    }
  }

  eventClicked(event: CalendarEvent<{ film: Film }>): void {
    window.open(
      `https://www.themoviedb.org/movie/${event.meta.film.id}`,
      "_blank"
    );
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }



}
